import React from 'react'
import { connect } from 'react-redux'
import { 
    Box, 
    Divider, 
    Grid, 
    Input , 
    FormLabel, 
    RadioGroup, 
    FormControlLabel, 
    Radio,
    Slider 
} from '@material-ui/core'
import RightPreviewPart from './RightPreviewPart'
import { generalChangeValue, changeFontValues } from '../actions/design'
import ColorPicker from '../components/ColorPicker'
import FontPicker from '../components/FontPicker'
import { viewStyles } from '../styles/styles'
import CancelFormButton from '../containers/CancelFormButton'


  


const LAYOUT_BR_MIN = 0
const LAYOUT_BR_MAX = 50
const LAYOUT_INPUT_BR_MIN = 0
const LAYOUT_INPUT_BR_MAX = 50
const SUBMIT_BR_MIN = 0
const SUBMIT_BR_MAX = 50

const borderRadiusMarks = [
    {
        value: LAYOUT_BR_MIN,
        label: `${LAYOUT_BR_MIN}px`
    },
    {
        value: LAYOUT_BR_MAX,
        label: `${LAYOUT_BR_MAX}px`
    }
]

const ViewDesign = ({ design, changeValue, changeFont }) => {

    const valuetext = (value) => {        
        value = `${value}px`;
        return value;
    }
    
    const classes = viewStyles()
    return (
        <Box className={classes.box_view}>
            <Box className={classes.leftBox}>                
                <Grid container >
                    <Grid item xs={10}>
                        <Box m="10px 0" className={classes.titleLeft}>Customize the design of your form</Box>
                    </Grid>
                    {/* LAYOUT BLOCK */}
                    <Grid item xs={12}>
                        <Box className={classes.designBlockTitle}>Layout</Box>
                    </Grid>
                    {/* ********** Text Align ********** */}
                    <Grid item xs={12}>
                        <Box className={classes.designBoxRow} display="flex" justifyContent="start" alignItems="center">
                            <FormLabel component="legend" className={classes.designFieldTitle}>Text Align:</FormLabel>
                            <RadioGroup aria-label="text-align" name="text-align" 
                            value={design.layout.textAlign} 
                            onChange={(e) => { changeValue("layout", "textAlign", e.target.value) }} row>
                                <FormControlLabel
                                value="left"
                                control={<Radio className={classes.designRadio} size="small" />}
                                label="Left"
                                labelPlacement="end"
                                className={classes.designRadioLabel}
                                />
                                <FormControlLabel
                                value="center"
                                control={<Radio className={classes.designRadio} size="small" />}
                                label="Center"
                                labelPlacement="end"
                                className={classes.designRadioLabel}
                                />
                                <FormControlLabel
                                value="right"
                                control={<Radio className={classes.designRadio} size="small" />}
                                label="Right"
                                labelPlacement="end"
                                className={classes.designRadioLabel}
                                />                                
                            </RadioGroup>
                        </Box>
                    </Grid>
                    {/* ********** Border Radius ********** */}
                    <Grid item xs={12}>
                        <Box className={classes.designBoxRow} display="flex" justifyContent="start" alignItems="center">
                            <FormLabel component="legend" className={classes.designFieldTitle}>Border Radius:</FormLabel>
                            <Slider
                                defaultValue={design.layout.borderRadius}
                                getAriaValueText={valuetext}
                                valueLabelDisplay="auto"                                
                                marks={borderRadiusMarks}
                                min={LAYOUT_BR_MIN}
                                max={LAYOUT_BR_MAX}
                                className={classes.designSlider}
                                onChange={(e,v) => { changeValue("layout", "borderRadius", v) }}
                                value={design.layout.borderRadius}
                            />
                        </Box>
                    </Grid>
                    {/* ********** Input Field Border Radius ********** */}
                    <Grid item xs={12}>
                        <Box className={classes.designBoxRow} display="flex" justifyContent="start" alignItems="center">
                            <FormLabel component="legend" className={classes.designFieldTitle}>Input Field Border Radius:</FormLabel>
                            <Slider
                                defaultValue={design.layout.fieldBorderRadius}
                                getAriaValueText={valuetext}
                                valueLabelDisplay="auto"                                
                                marks={borderRadiusMarks}
                                min={LAYOUT_INPUT_BR_MIN}
                                max={LAYOUT_INPUT_BR_MAX}
                                className={classes.designSlider}
                                onChange={(e,v) => { changeValue("layout", "fieldBorderRadius", v) }}
                                value={design.layout.fieldBorderRadius}
                            />
                        </Box>
                    </Grid>
                    {/* LAYOUT BLOCK END */}
                    <Grid item xs={6}>
                        <Box p="10px 0"><Divider></Divider></Box>                        
                    </Grid>
                    {/* BACKGROUNDS BLOCK */}
                    <Grid item xs={12}>
                        <Box className={classes.designBlockTitle}>Backgrounds</Box>
                    </Grid>
                    {/* ********** Background Color ********** */}
                    <Grid item xs={12}>
                        <Box className={classes.designBoxRow} display="flex" justifyContent="start" alignItems="center">
                            <FormLabel component="legend" className={classes.designFieldTitle}>Background Color:</FormLabel>
                            <ColorPicker className={classes.colorPicker} color={design.backgrounds.color} onChange={(color) => {changeValue("backgrounds", "color", color)}}></ColorPicker>
                        </Box>
                    </Grid>
                    {/* ********** Input Background Color ********** */}
                    <Grid item xs={12}>
                        <Box className={classes.designBoxRow} display="flex" justifyContent="start" alignItems="center">
                            <FormLabel component="legend" className={classes.designFieldTitle}>Input Background Color:</FormLabel>
                            <ColorPicker className={classes.colorPicker} color={design.backgrounds.inputColor} onChange={(color) => {changeValue("backgrounds", "inputColor", color)}}></ColorPicker>
                        </Box>
                    </Grid>
                    {/* BACKGROUNDS BLOCK END */}
                    <Grid item xs={6}>
                        <Box p="10px 0"><Divider></Divider></Box>
                    </Grid>
                    {/* FONTS BLOCK */}
                    <Grid item xs={12}>
                        <Box className={classes.designBlockTitle}>Fonts</Box>
                    </Grid>
                    {/* ********** Title ********** */}
                    <Grid item xs={12}>
                        <Box className={classes.designBoxRow} display="flex" justifyContent="start" alignItems="center">
                            <FormLabel component="legend" className={classes.designFieldTitle}>Title:</FormLabel>
                            <ColorPicker className={classes.colorPicker} 
                                color={design.fonts.title.color} 
                                onChange={(color) => {changeFont("title", "color", color)}}
                            ></ColorPicker>
                            <FontPicker font={design.fonts.title.font} 
                                className={classes.fontPicker} 
                                onChange={(font) => { changeFont("title", "font", font) }}
                            ></FontPicker>
                            <Input className={classes.fontSize} 
                                type="number"                             
                                value={design.fonts.title.size}
                                onChange={(e) => { changeFont("title", "size", parseInt(e.target.value)) }} 
                            />
                        </Box>
                    </Grid>
                    {/* ********** Label Text ********** */}
                    <Grid item xs={12}>
                        <Box className={classes.designBoxRow} display="flex" justifyContent="start" alignItems="center">
                            <FormLabel component="legend" className={classes.designFieldTitle}>Label Text:</FormLabel>
                            <ColorPicker className={classes.colorPicker} 
                                color={design.fonts.label.color} 
                                onChange={(color) => {changeFont("label", "color", color)}}
                            ></ColorPicker>
                            <FontPicker font={design.fonts.label.font} 
                                className={classes.fontPicker} 
                                onChange={(font) => { changeFont("label", "font", font) }}
                            ></FontPicker>
                            <Input className={classes.fontSize} 
                                type="number" 
                                value={design.fonts.label.size}
                                onChange={(e) => { changeFont("label", "size", parseInt(e.target.value)) }} 
                            />
                        </Box>
                    </Grid>
                    {/* ********** Input Text ********** */}
                    <Grid item xs={12}>
                        <Box className={classes.designBoxRow} display="flex" justifyContent="start" alignItems="center">
                            <FormLabel component="legend" className={classes.designFieldTitle}>Input Text:</FormLabel>
                            <ColorPicker className={classes.colorPicker} 
                                color={design.fonts.input.color} 
                                onChange={(color) => {changeFont("input", "color", color)}}
                            ></ColorPicker>
                            <FontPicker font={design.fonts.input.font} 
                                className={classes.fontPicker} 
                                onChange={(font) => { changeFont("input", "font", font) }}
                            ></FontPicker>
                            <Input className={classes.fontSize} 
                                type="number" 
                                value={design.fonts.input.size}
                                onChange={(e) => { changeFont("input", "size", parseInt(e.target.value)) }} 
                            />
                        </Box>
                    </Grid>
                    {/* ********** Button Text ********** */}
                    <Grid item xs={12}>
                        <Box className={classes.designBoxRow} display="flex" justifyContent="start" alignItems="center">
                            <FormLabel component="legend" className={classes.designFieldTitle}>Button Text:</FormLabel>
                            <ColorPicker className={classes.colorPicker} 
                                color={design.fonts.button.color} 
                                onChange={(color) => {changeFont("button", "color", color)}}
                            ></ColorPicker>
                            <FontPicker font={design.fonts.button.font} 
                                className={classes.fontPicker} 
                                onChange={(font) => { changeFont("button", "font", font) }}
                            ></FontPicker>
                            <Input className={classes.fontSize} 
                                type="number" 
                                value={design.fonts.button.size} 
                                onChange={(e) => { changeFont("button", "size", parseInt(e.target.value)) }}
                            />
                        </Box>
                    </Grid>
                    {/* FONTS BLOCK END */}                    
                    <Grid item xs={6}>
                        <Box p="10px 0"><Divider></Divider></Box>
                    </Grid>
                    {/* SUBMIT BUTTON BLOCK */}
                    <Grid item xs={12}>
                        <Box className={classes.designBlockTitle}>Submit Button</Box>
                    </Grid>
                    {/* ********** Button Alignment ********** */}
                    <Grid item xs={12}>
                        <Box className={classes.designBoxRow} display="flex" justifyContent="start" alignItems="center">
                            <FormLabel component="legend" className={classes.designFieldTitle}>Button Alignment:</FormLabel>
                            <RadioGroup aria-label="text-align" name="text-align" 
                            value={design.submit.alignment} 
                            onChange={(e) => { changeValue("submit", "alignment", e.target.value) }} row>
                                <FormControlLabel
                                value="left"
                                control={<Radio className={classes.designRadio} size="small" />}
                                label="Left"
                                labelPlacement="end"
                                className={classes.designRadioLabel}
                                />
                                <FormControlLabel
                                value="center"
                                control={<Radio className={classes.designRadio} size="small" />}
                                label="Center"
                                labelPlacement="end"
                                className={classes.designRadioLabel}
                                />
                                <FormControlLabel
                                value="right"
                                control={<Radio className={classes.designRadio} size="small" />}
                                label="Right"
                                labelPlacement="end"
                                className={classes.designRadioLabel}
                                />                                
                            </RadioGroup>
                        </Box>
                    </Grid>
                    {/* ********** Button Background Color ********** */}
                    <Grid item xs={12}>
                        <Box className={classes.designBoxRow} display="flex" justifyContent="start" alignItems="center">
                            <FormLabel component="legend" className={classes.designFieldTitle}>Button Background Color:</FormLabel>
                            <ColorPicker className={classes.colorPicker} color={design.submit.bgColor} onChange={(color) => {changeValue("submit", "bgColor", color)}}></ColorPicker>
                        </Box>
                    </Grid>
                    {/* ********** Border Radius ********** */}
                    <Grid item xs={12}>
                        <Box className={classes.designBoxRow} display="flex" justifyContent="start" alignItems="center">
                            <FormLabel component="legend" className={classes.designFieldTitle}>Border Radius:</FormLabel>
                            <Slider
                                defaultValue={0}
                                getAriaValueText={valuetext}
                                valueLabelDisplay="auto"                                
                                marks={borderRadiusMarks}
                                min={SUBMIT_BR_MIN}
                                max={SUBMIT_BR_MAX}
                                className={classes.designSlider}
                                onChange={(e,v) => { changeValue("submit", "borderRadius", v) }}
                                value={design.submit.borderRadius}
                            />
                        </Box>
                    </Grid>
                    {/* SUBMIT BUTTON BLOCK END */}
                </Grid>
            </Box>
            <Box className={classes.bottomBox} m="5px 0 5px 0px">
                <Grid item xs={2}>
                    <CancelFormButton />
                </Grid>
            </Box>
            <Divider orientation="vertical" className={classes.devider}></Divider>
            <Box className={classes.rightBox}>
                <RightPreviewPart></RightPreviewPart>
            </Box>                                  
        </Box>
    )
}

const mapStateToProps = state => ({
    ...state
})

const mapDispatchToProps = dispatch => ({
    changeValue: (sector, prop, val) => dispatch(generalChangeValue(sector, prop, val)),
    changeFont: (sector, prop, val) => dispatch(changeFontValues(sector, prop, val))
})

export default connect(mapStateToProps, mapDispatchToProps)(ViewDesign)